import type { LiveKpis } from '../domain/liveData';

interface KpiBarProps {
  /** Live values from GET /agent/commandCenter/summary. */
  kpis: LiveKpis;
  /** One sub-label per tile, already worded for the empty-fleet case. */
  footnotes: string[];
}

/** The three headline numbers above the agent sections; all three are live fleet data. */
const KpiBar = ({ kpis, footnotes }: KpiBarProps) => (
  <div className="kpis">
    <div className="kpi">
      <div className="l">Fleet nodes</div>
      <div className="v tabular">
        {kpis.nodesOnline}
        <small>/{kpis.nodesTotal}</small>
      </div>
      {footnotes[0] ? <div className="foot">{footnotes[0]}</div> : null}
    </div>
    <div className="kpi">
      <div className="l">Runs today</div>
      <div className="v tabular">{kpis.runsToday.toLocaleString('en-US')}</div>
      {footnotes[1] ? <div className="foot">{footnotes[1]}</div> : null}
    </div>
    <div className="kpi">
      <div className="l">Success rate</div>
      <div className="v tabular">
        {kpis.successRate.toFixed(1)}
        <small>%</small>
      </div>
      {footnotes[2] ? <div className="foot">{footnotes[2]}</div> : null}
    </div>
  </div>
);

export default KpiBar;
